import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { HisunHome } from './types';

export function useHisunHomeData(): Page<HisunHome>['templateFields'] {
  return useCurrentPage<Page<HisunHome>>().templateFields;
}
